import * as API from 'services/api';

export const getMovieData = async (id) => {
  try {
    const url = `/v1/rest/movie/${id}/`;
    const res = await API.get(url);
    return res.data;
  } catch (error) {
    return { info: '', status: error.response.status };
  }
};

export const getMoviePreviewData = async (id) => {
  try {
    const url = `/v2/rest/movie/preview/${id}/`;
    const res = await API.get(url);
    return res.data;
  } catch (error) {
    return { info: '', status: error.response.status };
  }
};

export const replaceMovieData = async (id, data) => {
  // should send all data (use after upload json)
  try {
    const url = `/v1/rest/movie/${id}/`;
    const res = await API.put(url, data);
    return res.data;
  } catch (error) {
    return { info: '', status: error.response.status };
  }
};

export const updateMovieData = async (id, data) => {
  // should send only changed data
  try {
    const url = `/v1/rest/movie/${id}/`;
    const res = await API.patch(url, data);
    return res.data;
  } catch (error) {
    return { info: '', status: error.response.status };
  }
};

export const createMovie = async (data) => {
  try {
    const url = '/v1/rest/movie/';
    const res = await API.post(url, data);
    return res.data;
  } catch (error) {
    return { info: '', status: error.response.status };
  }
};

export const deleteMovie = async (id) => {
  try {
    const url = `/v1/rest/movie/${id}`;
    const res = await API.remove(url);
    return res.data;
  } catch (error) {
    return { info: '', status: error.response.status };
  }
};

export const importFromFile = async (formData, onUploadProgress) => {
  try {
    const url = '/v1/upload/';
    const config = {
      onUploadProgress,
      headers: {
        accept: 'application/json',
        'Content-Type': 'multipart/form-data; boundary=something',
      },
    };

    const res = await API.put(url, formData, config);
    return { data: res.data, status: res.status };
  } catch (error) {
    return {
      error: '',
      data: error.response ? error.response.data : '',
      status: error.response ? error.response.status : '',
    };
  }
};

export const getFilmSuggestions = async (q) => {
  try {
    const url = '/v1/search_movies';
    const res = await API.get(url, { q });
    return res.data;
  } catch (error) {
    return [];
  }
};

export const getNameSuggestions = async (q, suggestionType) => {
  try {
    const url = `/v1/search_names/?name=${q}&role_type=${suggestionType}`;
    const res = await API.get(url);
    return res.data;
  } catch (error) {
    return [];
  }
};

export const getDistributorsSuggestions = async (q) => {
  try {
    const url = `/v2/distributors-search?name=${encodeURIComponent(q)}`;
    const res = await API.get(url);
    return res.data;
  } catch (error) {
    return [];
  }
};

export const getCompanySuggestions = async (q, suggestionType) => {
  try {
    const url = `/v2/companies-search?name=${encodeURIComponent(
      q,
    )}&company_type=${suggestionType}`;
    const res = await API.get(url);
    return res.data;
  } catch (error) {
    return [];
  }
};

export const getSimilarFilms = async (uid) => {
  try {
    const url = `/v1/search_similar/${uid}`;
    const res = await API.get(url);
    return res.data;
  } catch (error) {
    return [];
  }
};

export const getFilmTemplate = async () => {
  try {
    const url = `/v1/get_template/`;
    const config = {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'blob',
      },
    };
    const res = await API.get(url, null, config);
    return res;
  } catch (error) {
    return {
      error: '',
      data: error.response?.data,
      status: error.response?.status,
    };
  }
};
